<template>
    <b-modal
        id="sub-assignment-restore-modal"
        v-model="modal"
        modal-class="apprentice-default-modal"
        :title="$t('assignment.restore_sub_assignment')"
        ok-only
        :ok-title="$t('common.close')"
        @ok="onOk">
        <design-2021-apprentice-data-table
            class="deleted-categories-table"
            v-if="subAssignments.length"
            :fields="fields"
            :items="subAssignments">
            <template v-slot:cell(actions)="data">
                <div class="group-actions">
                    <b-button
                        class="btn-recycle remove-icon-margin"
                        v-b-tooltip="$t('assignment.restore_sub_assignment')"
                        variant="primary-icon-only"
                        @click="restore(data.item)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>
        <div
            class="not-found with-header removed-sub-assignments-not-found"
            v-else>
            <div class="btn-recycle icon"></div>
            <div class="alert-notice">
                {{ $t('assignment.restore_sub_assignment.no_deleted_subassignments_found') }}
            </div>
        </div>
    </b-modal>
</template>

<script>
import { ords } from '../../../../app';

const subAssignmentOrds = ords.use('subAssignment');
export default {
    name: 'design-2021-portfolio-edit-restore-sub-assignment-modal-component',
    props: {
        assignmentIn: {
            type: Object,
            required: true,
        },
        groupIdIn: {
            type: Number,
            required: false,
            default: null,
        },
    },

    data() {
        return {
            modal: false,
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            subAssignments: [],
        };
    },

    methods: {
        show() {
            this.axios.get(this.routes.getDeletedSubAssignments(this.assignmentIn.id)).then(
                (response) => {
                    this.subAssignments = response.data;
                    this.modal = true;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        onOk() {
            window.location.reload();
        },

        restore(restoreSubAssignment) {
            this.alert
                .confirm(
                    this.$t('assignment.restore_sub_assignment'),
                    this.$t('assignment.restore_sub_assignment.are_you_sure'),
                    this.$t('common.yes_recover'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        let data = {
                            sub_assignment_id: restoreSubAssignment.id,
                            group_id: this.groupIdIn,
                        };

                        this.axios.post(this.routes.subAssignmentRestore(this.assignmentIn.id), data).then(
                            (response) => {
                                this.subAssignments = this.subAssignments.filter(
                                    (assignment) => assignment.id !== response.data.id,
                                );
                                if (this.groupIdIn) {
                                    this.assignmentIn.addRelation('sub_assignments', response.data);
                                }
                                this.$emit('sub-assignment-restored', response.data);
                                this.alert.success();
                            },
                            (error) => {
                                return this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
    },
};
</script>

<style scoped lang="scss"></style>
